//copmmon import
import bcrypt from "bcryptjs";
import axios from "axios";

//utils
import CallURL from "../../utils/API/CallURL";
import { gotoeditprofile, gotologin } from "../../utils/Helper/JSHelper";

//clear storage
export function clearStorage() {
  localStorage.clear();
  sessionStorage.clear();
}
//set_login_detail
export function set_login_detail(userfullname, userseckey) {
  //set localstorage
  localStorage.setItem("userseckey", userseckey);
  set_userfullname(userfullname);
}
//set_userfullname
export function set_userfullname(userfullname) {
  localStorage.setItem("userfullname", userfullname);
}
//get_userfullname
export function get_userfullname() {
  return localStorage.getItem("userfullname") != null &&
    localStorage.getItem("userfullname") != ""
    ? localStorage.getItem("userfullname")
    : "";
}
//generate unique id
export function getuniquedeviceid() {
  //device uniwue id
  var navigator_info = window.navigator;
  var screen_info = window.screen;
  var uid = "YSIQGESQW";
  uid += navigator_info.userAgent.replace(/\D+/g, "");
  //uid += navigator_info.mimeTypes.length;
  //uid += navigator_info.plugins.length;
  //uid += screen_info.height || "";
  //uid += screen_info.width || "";
  //uid += screen_info.pixelDepth || "";
  uid += "AHGQWLNLWWDOIO";
  //console.log(uid);
  //encrypt
  // SALT should be created ONE TIME upon sign up
  //const salt = bcrypt.genSaltSync(10);
  //static active salt
  const salt = "$2a$10$S/Fv1q8heZFz3Y8lXvlmUO";
  const hashedUid = bcrypt.hashSync(uid, salt);
  //return encrypted
  return hashedUid;
}
//get userseckey
export function get_userseckey() {
  return localStorage.getItem("userseckey") != null &&
    localStorage.getItem("userseckey") != ""
    ? localStorage.getItem("userseckey")
    : "";
}
//check is login
export function isloginuser() {
  var islogin = false;
  var userseckey = localStorage.getItem("userseckey");
  if (userseckey != null) {
    islogin = true;
  }
  return islogin;
}
//signout
export function signoutuser() {
  //go to login page
  gotologin();
}
//signoutuser_confirm
export function signoutuser_confirm() {
  var r = false;
  r = window.confirm("Do you want to Logout ?");
  if (r == true) {
    signoutuser();
  }
}
//authentication tocken check
export function check_authorized(usertype) {
  // Create an object of formData
  const formData = new Object();
  // Update the formData object
  formData.secuserkey = get_userseckey();
  formData.deviceid = getuniquedeviceid();
  formData.usertype = usertype;
  // Send formData object
  axios
    .post(CallURL.tokenauth, formData)
    .then((response) => {
      //console.log(response);
      //alert(response.data.apires);
      if (response.data.apires == "unauthorized") {
        //make logout
        signoutuser();
      } else if (response.data.apires == "authorized") {
        //check is profile complete or not
        if (response.data.is_complete == "0") {
          //gotoeditprofile();
        }
      }
    })
    .catch((error) => {
      console.log(error);
    });
}
//check user admin or not
export function check_is_admin() {
  // Create an object of formData
  const formData = new Object();
  // Update the formData object
  formData.secuserkey = get_userseckey();
  formData.deviceid = getuniquedeviceid();
  // Send formData object
  axios
    .post(CallURL.isadmin, formData)
    .then((response) => {
      //console.log(response);
      //alert(response.data.apires);
      if (response.data.apires == "yes") {
        return "yes";
      } else {
        return "no";
      }
    })
    .catch((error) => {
      console.log(error);
      return "no";
    });
}
